import { Calendar } from "lucide-react";

const Items = ({ fields }) => {
  return (
    <dl className=" bg-white shadow rounded-lg overflow-hidden divide-y divide-gray-200">
      {fields.map((field, index) => (
        <div
          key={field.label}
          className={`px-6 py-4 sm:grid sm:grid-cols-2 sm:gap-6 ${
            index % 2 !== 0 ? "bg-gray-50" : "bg-white"
          } hover:bg-gray-100 transition-colors duration-150`}
        >
          <dt className="text-sm font-medium text-gray-500">{field.label}</dt>
          <dd className="mt-1 text-sm text-gray-900 sm:mt-0">
            {Array.isArray(field.value) ? (
              <div className="space-y-2">
                {field.value.map((item, idx) => (
                  <p
                    key={idx}
                    className="pb-1 border-b border-dashed border-gray-200 last:border-0 last:pb-0"
                  >
                    {item}
                  </p>
                ))}
              </div>
            ) : field.type === "link" ? (
              <a
                href={field.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                {field.linkText}
              </a>
            ) : (
              field.value
            )}
          </dd>
        </div>
      ))}
    </dl>
  );
};

const DetailsItems = ({ fields, data, title, costumFields, costumArrays }) => {
  return (
    <>
      <h2 className="text-xl font-semibold mb-3">{title}</h2>
      <div className="flex items-center text-sm text-gray-500 mb-6">
        <Calendar className="w-4 h-4 mr-1" />
        {data && data.version && <span>Version {data.version}</span>}
        {data && data.version && <span className="mx-2">|</span>}
        {data && data.lastUpdate && (
          <span>Date de dernière mise à jour: {data.lastUpdate}</span>
        )}
      </div>

      <Items fields={fields} />
      {data.description && (
        <ul className="ml-4  mt-3 mb-4 px-2 list-disc space-y-1">
          {data.description.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      )}
      {costumArrays &&
        costumArrays.length > 0 &&
        costumArrays.map((field, index) => (
          <div key={index} className=" mt-4">
            {field.title && (
              <h4 className=" text-[1rem] font-semibold mb-2">{field.title}</h4>
            )}
            {field.fields && field.fields.length > 0 && (
              <Items fields={field.fields} />
            )}
          </div>
        ))}

      {costumFields &&
        costumFields.length > 0 &&
        costumFields.map((field, index) => (
          <div key={index} className=" mt-4">
            <h4 className=" text-[1rem] font-semibold mb-2">{field.title}</h4>
            <p>{field.desc}</p>
          </div>
        ))}
    </>
  );
};

export default DetailsItems;
